<template>
  <div class="orders-box">
    <Loading :show="$apollo.loading" />

    <van-tabs v-model="active" line-height="2" color="#ff5600" title-active-color="#ff5600" title-inactive-color="#999">
      <van-tab title="全部">
        <div class="order-panel" v-for="(order, index) in orders" :key="index">

          <div class="body" @click="toDetail(order)">
            <div class="hd">
              <img :src="order.subject.smallLogoImg" alt="">
            </div>
            <div class="bd">
              <div class="bd-title">{{ order.subject.title }}</div>
              <div class="bd-desc">
                <span class="status" v-if="order.pink" :class="order.pink.status">{{ orderStatusText(order.status, order.pink ? order.pink.status : null) }}</span>
                <span class="status" v-else :class="order.status">{{ orderStatusText(order.status, order.pink ? order.pink.status : null) }}</span>
                <span class="amount">
                  {{ orderFeeText(order.status) }}:
                  <b>￥{{ order.totalFee }}</b>
                </span>
              </div>
            </div>
          </div>
          <!-- 显示邀请按钮: 订单已支付 & 存在拼团信息 & 拼团状态为开启和拼团中 -->
          <div class="footer" v-if="order.status === 'paid' && order.pink && order.pink.status !== 'success' && order.pink.countDownSecond > 0">
            <div class="bd">拼团剩余时间: <van-count-down :time="order.pink.countDownSecond * 1000" @finish="orders.splice(index, 1)" /></div>
            <div class="ft">
              <van-button type="primary" round @click="toInvite(order.pink.id)">邀请拼团</van-button>
            </div>
          </div>
        </div>
        <Empty :show="orders.length == 0" />
      </van-tab>

      <van-tab title="待付款">
        <div v-if="waitingOrders">
          <div class="order-panel" v-for="(order, index) in waitingOrders" :key="index">
            <div class="body" @click="toDetail(order)">
              <div class="hd">
                <img :src="order.subject.smallLogoImg" alt="">
              </div>
              <div class="bd">
                <div class="bd-title">{{ order.subject.title }}</div>
                <div class="bd-desc">
                  <span class="status wait_pay">待付款</span>
                  <span class="amount">
                    {{ orderFeeText(order.status) }}:
                    <b>￥{{ order.totalFee }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Empty :show="waitingOrders.length == 0" />
        </div>
      </van-tab>

      <van-tab title="拼团中">
        <div v-if="pinkingOrders">
          <div class="order-panel" v-for="(order, index) in pinkingOrders" :key="index">
            <div class="body" @click="toDetail(order)">
              <div class="hd">
                <img :src="order.subject.smallLogoImg" alt="">
              </div>
              <div class="bd">
                <div class="bd-title">{{ order.subject.title }}</div>
                <div class="bd-desc">
                  <span class="status open ongoing">拼团中</span>
                  <span class="amount">
                    {{ orderFeeText(order.status) }}:
                    <b>￥{{ order.totalFee }}</b>
                  </span>
                </div>
              </div>
            </div>
            <div class="footer" v-if="order.status === 'paid' && order.pink && order.pink.status !== 'success' && order.pink.countDownSecond > 0" >
              <div class="bd">拼团剩余时间: <van-count-down :time="order.pink.countDownSecond * 1000" @finish="orders.splice(index, 1)" /></div>
              <div class="ft">
                <van-button type="primary" round @click="toInvite(order.pink.id)">邀请拼团</van-button>
              </div>
            </div>
          </div>
          <Empty :show="pinkingOrders.length == 0" />
        </div>
      </van-tab>
      <van-tab title="拼团失败">
        <div v-if="pinkFailOrders">
          <div class="order-panel" v-for="(order, index) in pinkFailOrders" :key="index">
            <div class="body" @click="toDetail(order)">
              <div class="hd">
                <img :src="order.subject.smallLogoImg" alt="">
              </div>
              <div class="bd">
                <div class="bd-title">{{ order.subject.title }}</div>
                <div class="bd-desc">
                  <span class="status fail">拼团失败</span>
                  <span class="amount">
                    {{ orderFeeText(order.status) }}:
                    <b>￥{{ order.totalFee }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Empty :show="pinkFailOrders.length == 0" />
        </div>
      </van-tab>
      <van-tab title="已完成">
        <div v-if="orderedOrders">
          <div class="order-panel" v-for="(order, index) in orderedOrders" :key="index">
            <div class="body" @click="toDetail(order)">
              <div class="hd">
                <img :src="order.subject.smallLogoImg" alt="">
              </div>
              <div class="bd">
                <div class="bd-title">{{ order.subject.title }}</div>
                <div class="bd-desc">
                  <span class="status success">已完成</span>
                  <span class="amount">
                    {{ orderFeeText(order.status) }}:
                    <b>￥{{ order.totalFee }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Empty :show="orderedOrders.length == 0" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Loading from '@/components/Loading'
import Empty from '@/components/Empty'
import { myOrders } from './query.gql'
export default {
  name: 'orders',
  data() {
    return {
      active: 0,
      orders: []
    }
  },
  components: {
    Loading,
    Empty
  },
  computed: {
    pinkingOrders: function() {
      return this.orders.filter(o => o.types === 'pink_buy' && ['open', 'ongoing'].includes(o.pink.status))
    },
    pinkFailOrders: function() {
      return this.orders.filter(o => o.types === 'pink_buy' && o.pink.status === 'fail')
    },
    waitingOrders: function() {
      return this.orders.filter(o => o.status === 'wait_pay')
    },
    orderedOrders: function() {
      return this.orders.filter(o => o.status === 'paid')
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.loadOrders()
  },
  methods: {
    loadOrders() {
      const self = this
      self.$apollo.query({
        query: myOrders,
        fetchPolicy: 'no-cache'
      }).then(res => {
        console.log('我的订单', res.data)
        const { orders } = res.data
        self.orders = orders
      }).catch(err => {
        console.error('page：orders/index。请求myOrders报错', err)
      })
    },
    orderStatusText(orderStatus, pinkStatus) {
      let statusText
      switch (orderStatus) {
        case 'wait_pay':
          statusText = '未支付'
          break
        case 'paid':
          if (pinkStatus) {
            if (pinkStatus === 'success') {
              statusText = '已完成'
            } else if (pinkStatus === 'fail') {
              statusText = '拼团失败'
            } else {
              statusText = '拼团中'
            }
          } else {
            statusText = '已完成'
          }
          break
        case 'cancel':
          statusText = '已取消'
          break
        case 'refund':
          statusText = '已退款'
          break
        case 'pink_full':
          statusText = '拼团已满'
          break
        default:
          statusText = ''
          break
      }
      return statusText
    },
    orderFeeText(status) {
      if (status === 'wait_pay') {
        return '待付金额'
      } else if (status === 'paid') {
        return '实付金额'
      } else if (status === 'refund') {
        return '退款金额'
      } else {
        return '订单金额'
      }
    },
    toInvite(id) {
      this.$router.push({
        name: 'groupInvite',
        params: { id }
      })
    },
    toDetail(order) {
      if ((order.types === 'full_buy' && order.status === 'paid') || (order.types === 'pink_buy' && order.status === 'paid' && order.pink.status === 'success')) {
        // 成功
        this.$router.push({
          name: 'learn',
          query: { id: order.subject.id }
        })
      } else {
        this.$router.push({
          name: 'subject',
          query: { id: order.subject.id }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.orders-box {
  background: #f7f4f8;
  min-height: 100vh;

  .van-tab__pane {
    padding: 15px;
  }
  .order-panel {
    background: #fff;
    border-radius: 8px;
    padding: 9px;
    margin-bottom: 15px;
    .body{
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      .hd{
        width: 75px;
        height: 75px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 12px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .bd{
        flex: 1;
        .bd-title{
          font-size: 16px;
          color: #404040;
          font-weight: bold;
          padding: 10px 0 26px;
        }
        .bd-desc{
          display: flex;
          .status {
            flex: 1;
            font-weight: bold;
            font-size: 15px;
            &.wait_pay {
              color: #FF8358;
            }
            &.success {
              color: #66bb33;
            }
            &.cancel {
              color: rgb(155, 166, 178);
            }
            &.fail, &.refund {
              color: #fb3506;
            }
            &.open, &.ongoing {
              color: #ff5600;
            }
          }
          .amount{
            font-size: 13px;
            color: #999;
            b{
              color: #ff5600;
              font-weight: bold;
            }
          }
        }
      }
    }
    .footer{
      position: relative;
      padding-top: 9px;
      display: flex;
      align-items: center;
      &:before{
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        top: 0;
        left: 0;
        border-top: 1px solid #f5f5f5;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .bd{
        flex: 1;
        color: #999;
        font-size: 13px;
        font-weight: bold;
      }
      .ft{
        .van-button{
          height: 32px;
          line-height: 32px;
          font-size: 16px;
          font-weight: bold;
          background: linear-gradient(to right,#e2b4ff,#ac8efa);
          border: none;
        }
      }
    }
  }

  .van-count-down{
    display: inline;
    color: #999;
    font-size: 13px;
    font-weight: normal;
  }
}
</style>
